<script setup lang="ts">
import AppButton from '@/shared/ui/AppButton/index';
import JournalCard from '@/entities/journal/ui/JournalCard.vue';

import type { IJournalArticle } from '@/entities/journal/model/types';

withDefaults(
  defineProps<{
    lawyerArticles: IJournalArticle[];
    isShowLoadMore?: boolean;
  }>(),
  {
    isShowLoadMore: false,
  },
);

const emit = defineEmits<{
  (e: 'load'): void;
}>();

const isMobile: boolean = useIsMobile();

const loadMore = (): void => {
  emit('load');
};
</script>

<template>
  <div :class="['lawyer-articles', { _mobile: isMobile }]">
    <div class="lawyer-articles__title">Другие статьи автора</div>
    <ul class="lawyer-articles__list">
      <li v-for="card in lawyerArticles" :key="card.id" class="lawyer-articles__item">
        <JournalCard :card="card" is-detail-page />
      </li>
    </ul>
    <AppButton
      v-if="isShowLoadMore"
      class="lawyer-articles__button"
      button-text="Показать ещё"
      is-big
      is-bordered
      is-white
      is-small
      @click="loadMore"
    />
  </div>
</template>

<style lang="less">
.lawyer-articles {
  .flex-column(@size-x5);

  padding: @size-x5;
  border: 1px solid @color-gallery;
  border-radius: @main-size;

  &__title {
    font-size: 18px;
    line-height: 23px;
    font-weight: 700;
  }

  &__list {
    .flex-column(@size-x4);
  }

  &__button {
    margin: 0 auto;
  }

  &._mobile &__button.app-button._small {
    width: 100%;
  }
}
</style>
